import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { StarGreyIcon, StarYellowIcon } from 'Stories/Icon/Icon.stories'
import { SelectResponseRatingProps } from './props'
import { Select, SelectRatingOption, SelectRatingPlaceholder } from './styles'

const reviewResponseRatingOptions = [
  {
    value: 5,
    label: (
      <SelectRatingOption>
        <StarYellowIcon />
        <StarYellowIcon />
        <StarYellowIcon />
        <StarYellowIcon />
        <StarYellowIcon />
      </SelectRatingOption>
    ),
  },
  {
    value: 4,
    label: (
      <SelectRatingOption>
        <StarYellowIcon />
        <StarYellowIcon />
        <StarYellowIcon />
        <StarYellowIcon />
        <StarGreyIcon />
      </SelectRatingOption>
    ),
  },
  {
    value: 3,
    label: (
      <SelectRatingOption>
        <StarYellowIcon />
        <StarYellowIcon />
        <StarYellowIcon />
        <StarGreyIcon />
        <StarGreyIcon />
      </SelectRatingOption>
    ),
  },
  {
    value: 2,
    label: (
      <SelectRatingOption>
        <StarYellowIcon />
        <StarYellowIcon />
        <StarGreyIcon />
        <StarGreyIcon />
        <StarGreyIcon />
      </SelectRatingOption>
    ),
  },
  {
    value: 1,
    label: (
      <SelectRatingOption>
        <StarYellowIcon />
        <StarGreyIcon />
        <StarGreyIcon />
        <StarGreyIcon />
        <StarGreyIcon />
      </SelectRatingOption>
    ),
  },
]

const SelectResponseRatingComponent: FunctionComponent<SelectResponseRatingProps> = ({
  ref,
  onChange,
  value,
}) => {
  const { t } = useTranslation()
  return (
    <Select
      ref={ref}
      isSearchable={false}
      options={reviewResponseRatingOptions}
      placeholder={
        <SelectRatingPlaceholder>
          <StarGreyIcon />
          {t('campaignResultsPage.chooseRate')}
        </SelectRatingPlaceholder>
      }
      classNamePrefix="review-rating"
      value={reviewResponseRatingOptions.find(c => c.value === value)}
      // @ts-ignore
      onChange={(val: { value: { value: number } }) => onChange(val.value)}
    />
  )
}

export default SelectResponseRatingComponent
